// extracted by mini-css-extract-plugin
export var hidden = "styles-module--hidden--72849";
export var hidden__first = "styles-module--hidden__first--37b35";
export var notification = "styles-module--notification--27ae9";
export var ratings = "styles-module--ratings--46557";
export var recomendation__title = "styles-module--recomendation__title--af7e9";
export var recomendations = "styles-module--recomendations--f5218";
export var recomendations__indications = "styles-module--recomendations__indications--b1c1a";
export var recomendations__indications__item = "styles-module--recomendations__indications__item--ad95a";
export var recomendations__line__graph = "styles-module--recomendations__line__graph--2da92";
export var recomendations__line__titles = "styles-module--recomendations__line__titles--590cb";
export var tooltip = "styles-module--tooltip--a9683";
export var tooltip__second = "styles-module--tooltip__second--73bec";
export var vibrations__rating = "styles-module--vibrations__rating--cd245";